import React, { useEffect, useState } from 'react';

function Splash({ onSplashComplete }) {
  // Extract domain name for dynamic image loading
  const fullOrigin = window.location.origin;
  const hostname = window.location.hostname;
  const origin = hostname
    .replace(/^www\./, '')
    .replace(/\.(com|live|net|bet|buzz|win|world|pro)$/i, '');
  
  console.log("Splash debug - Full origin:", fullOrigin);
  console.log("Splash debug - Hostname:", hostname);
  console.log("Splash debug - Extracted domain for image:", origin);
  
  const [imageError, setImageError] = useState(false);
  const [visible, setVisible] = useState(true);
  const [imageSrc, setImageSrc] = useState(`${process.env.PUBLIC_URL}/splash/${origin}.gif`);
  
  // This useEffect guarantees the splash screen stays visible for exactly 2 seconds
  useEffect(() => {
    console.log("Splash screen - Starting 2-second timer");
    
    // Force splash screen to show for exactly 2 seconds, regardless of data loading
    const displayTimer = setTimeout(() => {
      console.log("Splash screen - 2 seconds elapsed, starting fade out");
      
      // Add a class to fade out the splash screen
      const splashElement = document.querySelector('.splash-screen');
      if (splashElement) {
        splashElement.classList.add('fade-out');
      }
      
      // After the fade animation completes, call the completion callback and remove from DOM
      const fadeTimer = setTimeout(() => {
        console.log("Splash screen - Fade out complete, removing from DOM");
        setVisible(false); // Remove from DOM completely
        if (onSplashComplete) {
          console.log("Splash screen - Calling onSplashComplete callback");
          onSplashComplete();
        }
      }, 500); // 500ms for fade-out animation
      
      return () => clearTimeout(fadeTimer);
    }, 2000); // Always show for exactly 2000ms (2 seconds)
    
    // Clean up timer if component unmounts
    return () => clearTimeout(displayTimer);
  }, [onSplashComplete]);

  const handleImageError = () => {
    // If the domain-specific image fails, try default.gif
    if (imageSrc.includes(`${origin}.gif`)) {
      console.log(`Splash image ${origin}.gif not found, falling back to default.gif`);
      setImageSrc(`${process.env.PUBLIC_URL}/splash/default.gif`);
    } else {
      // If default.gif also fails, show loading animation
      console.log("Default splash image also failed, showing loading animation");
      setImageError(true);
    }
  };

  const lazy = () => {
    // Image loaded successfully, no action needed
  };

  // Don't render anything if not visible
  if (!visible) return null;

  // Special case for jitbuzz domain
  if (origin === 'jitbuzz') {
    return (
      <div className="splash-screen">
        <div className="loader-box ng-star-inserted">
          <div className="loader-jb">
            <div className="loader-jb">
              <div className="all-loader-frame">
                <div className="loader-1" />
                <div className="loader-bg" />
                <div className="loader-2" />
                <div className="loader-bg2" />
              </div>
              <div className="jb-logo-bg">
                <div
                  className="jb-logo"
                  style={{
                    backgroundImage:
                      'url("https://img.j189eb.com/jb/h5/assets/images/loader/jb_logo.png?v=1743412106882")',
                  }}
                />
                <div
                  className="jb-logo-man"
                  style={{
                    backgroundImage:
                      'url("https://img.j189eb.com/jb/h5/assets/images/loader/jblogo-man.png?v=1743412106882")',
                  }}
                />
              </div>
              <div
                className="jb-logo-speedline"
                style={{
                  backgroundImage:
                    'url("https://img.j189eb.com/jb/h5/assets/images/loader/jb-loader-03.png?v=1743412106882")',
                }}
              />
              <div
                className="jb-logo-ball"
                style={{
                  backgroundImage:
                    'url("https://img.j189eb.com/jb/h5/assets/images/loader/jb_logo-ball.png?v=1743412106882")',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Standard splash screen design for other domains
  return (
    <div className="splash-screen">
      {imageError ? (
        <div className="three-dots-loading">
          <span></span>
          <span></span>
          <span></span>
        </div>
      ) : (
        <img
          src={imageSrc}
          onError={handleImageError}
          onLoad={lazy}
          alt="Loading..."
        />
      )}
    </div>
  );
}

export default Splash;
